import React, {ReactElement, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import classnames from 'classnames';
import Notifications from 'shared/components/notifications';
import ImpostorToolbar from 'shared/components/impostor-toolbar';
import AwardNotifications from 'shared/components/award-notifications';
import Suspense from 'src/components/Suspense';
import AppLayout from './app-layout';
import ToolbarNotification from './toolbar-notification';

export interface StudentRootAppProps {
  appModals: ReactElement;
  appNavbar: ReactElement;
  appRoutes: ReactElement;
  disableImpostorToolbar?: boolean;
  onHistoryChange: (path: string) => {
    hasBackground: boolean;
    hasContainer: boolean;
  };
}

export default function StudentRootApp(props: StudentRootAppProps): ReactElement | null {
  const history = useHistory();
  const [hasContainer, setHasContainer] = useState(true);
  const [hasBackground, setHasBackground] = useState(false);
  const path = history.location.pathname;

  useEffect(() => {
    const page = props.onHistoryChange(path);
    setHasContainer(page.hasContainer);
    setHasBackground(page.hasBackground);
  }, [path]);

  return (
    <AppLayout
      topToolbars={
        <>
          <ToolbarNotification />
          {!props.disableImpostorToolbar && <ImpostorToolbar />}
          {props.appNavbar}
        </>
      }
    >
      <div className={classnames('page-wrapper', {'with-background': hasBackground})}>
        <AwardNotifications />
        <Notifications />
        <div id="main" role="main" tabIndex={-1}>
          <div className={classnames({container: hasContainer})}>
            {props.appModals}
            <Suspense>{props.appRoutes}</Suspense>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
